import {StandardInputField} from 'components/system/fields/StandardInputField'

type Props = {
  bookingUuid: string
  unitItemId: string
  questionId: string
  type: string
}

export const Input = ({bookingUuid, unitItemId, questionId, type}: Props) => {
  return <StandardInputField type={type} name={`[${bookingUuid}][${unitItemId}][${questionId}]`} />
}
